import { renderValidatorMessage } from "../../actions/renderValidatorMessage";

export const ContainersValidatorsColumns = (t: any) => [
  {
    key: "createdDate",
    name: t('validators.columns.createdDate'),
    fieldName: "createdDateStr",
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
  },
  {
    key: "message",
    name: t('validators.columns.message'),
    fieldName: "message",
    minWidth: 300,
    maxWidth: 350,
    isResizable: true,
    onRender: (item: any) => renderValidatorMessage(item, t),
  },
  {
    key: "ContainerName",
    name: t('validators.columns.containerName'),
    fieldName: "ContainerName",
    minWidth: 130,
    maxWidth: 160,
    isResizable: true,
  },
  {
    key: "SerNo",
    name: t('validators.columns.serialNumber'),
    fieldName: "SerNo",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "approvedDate",
    name: t('validators.columns.approvedDate'),
    fieldName: "approvedDateStr",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "comment",
    name: t('validators.columns.comment'),
    fieldName: "comment",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
];